import { Button, Icon } from '@dnb/eufemia';
import { star as FavouriteIcon } from '@dnb/eufemia/icons';
import { SpacingElementProps } from '@dnb/eufemia/shared/types';
import styled from '@emotion/styled';

const FavouriteFilledIcon = styled(FavouriteIcon)`
  fill: var(--color-accent-yellow);
  &.favourite-button [stroke] {
    stroke: var(--color-accent-yellow);
  }
`;

interface FavouriteProps extends SpacingElementProps {
  onClick: () => void;
  isFavourite: boolean;
  isLoading: boolean;
}

export default function FavouriteButton({ onClick, isFavourite, isLoading = false, ...props }: FavouriteProps) {
  return (
    <Button
      bottom="small"
      disabled={isLoading}
      icon={
        isFavourite ? (
          <Icon icon={<FavouriteFilledIcon className="favourite-button" />} size="small" />
        ) : (
          <Icon icon={FavouriteIcon} size="small" />
        )
      }
      onClick={onClick}
      size="small"
      {...props}
    />
  );
}
